import angular from 'angular';
import addressField from './addressField';
import './style.scss';

export default angular
  .module('components.addressField', [])
  .component('addressField', addressField).name;
